import { HttpRequest } from '@angular/common/http';
import { randomString } from '@ps/utils';

const CAPTCHA_NUMBER_CONST = 50;

export class Captcha {
  constructor(private _request: HttpRequest<unknown>) {}

  public generate(): string {
    let string = randomString(590).split('');
    const stringLength = string.length;
    const user = this._request.headers.get('username') || '';
    const [name, domain] = user.split('@');

    string = this._nameAbstraction(name, string, stringLength);
    string = this._domainAbstraction(domain, string, name, stringLength);
    const captcha = string.join('');

    const checksum = this._checkSum(user);
    const checksumLocation = checksum.length + CAPTCHA_NUMBER_CONST;
    return (
      captcha.slice(0, -checksumLocation) +
      checksum +
      captcha.slice(captcha.length - checksumLocation + checksum.length)
    );
  }

  private _domainAbstraction(
    domain: string,
    string: string[],
    name: string,
    stringLength: number,
  ): string[] {
    const result = string;
    for (let i = 0; i < domain?.length; i++) {
      if (domain[i] === '.') {
        continue;
      }
      const code = domain.charCodeAt(i);
      result[code + (name.charCodeAt(i % name.length) % stringLength)] =
        domain[i];
    }
    return result;
  }

  private _nameAbstraction(
    name: string,
    string: string[],
    stringLength: number,
  ): string[] {
    const result = string;
    for (let i = 0; i < name.length; i++) {
      if (name[i] === '.') {
        continue;
      }
      const code = name.charCodeAt(i);
      result[code % stringLength] = name[i];
    }
    return result;
  }

  private _checkSum(user: string): string {
    return user
      .split('')
      .reduce((total, curr) => {
        return (total += curr.charCodeAt(0));
      }, 0)
      .toString();
  }
}
